/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
import { Observable } from '../Observable';
export function isObservable(obj) {
    return !!obj && (obj instanceof Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}
//# sourceMappingURL=isObservable.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isObservable.js
// module id = 2055
// module chunks = 0